<template>
    <div>
        <form @submit="formWillSubmit">
            <div class="tw-flex tw-justify-center">
                <div class="tw-w-full md:tw-w-2/3">
                    <h3 :class="theme==='light' ? 'tw-text-white' : 'tw-text-gray-800'">
                        {{ __('purchase.billing_details_title') }}
                    </h3>
                </div>
            </div>

            <div class="tw-flex tw-justify-center">
                <div class="tw-w-full md:tw-w-2/3">
                    <div class="tw-flex tw-flex-wrap tw-justify-center">
                        <div class="tw-w-full md:tw-w-1/2 tw-pr-2">
                            <input
                                type="text"
                                class="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-bg-transparent tw-rounded tw-mt-2"
                                :placeholder="__('purchase.first_name_placeholder')"
                                v-model="firstName"
                                :class="{ 'tw-border-red-500': showFirstNameError, 'tw-text-white': (theme === 'light') }"
                                @blur="fieldTouched.first_name = true"
                                @input="fieldTouched.first_name = true"
                            />
                            <span v-show="showFirstNameError" class="tw-text-red-600">
                                {{ errors.first_name }}
                            </span>
                        </div>
                        <div class="tw-w-full md:tw-w-1/2 tw-pl-2">
                            <input
                                type="text"
                                class="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-bg-transparent tw-rounded tw-mt-2"
                                :placeholder="__('purchase.last_name_placeholder')"
                                v-model="lastName"
                                :class="{ 'tw-border-red-500': showLastNameError, 'tw-text-white': (theme === 'light') }"
                                @blur="fieldTouched.last_name = true"
                                @input="fieldTouched.last_name = true"
                            />
                            <span v-show="showLastNameError" class="tw-text-red-600">
                                {{ errors.last_name }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tw-flex tw-justify-center">
                <div class="tw-w-full md:tw-w-2/3">
                    <input
                        type="text"
                        class="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-bg-transparent tw-rounded tw-mt-2"
                        :placeholder="__('purchase.email_address_placeholder')"
                        v-model="emailAddress"
                        ref="email_address"
                        :class="{ 'tw-border-red-500': showEmailAddressError, 'tw-text-white': (theme === 'light') }"
                        @blur="fieldTouched.email_address = true"
                        @input="fieldTouched.email_address = true"
                    />
                    <span v-show="showEmailAddressError" class="tw-text-red-600">
                        {{ errors.email_address }}
                    </span>
                </div>
            </div>

            <div class="tw-flex tw-justify-center">
                <div class="tw-w-full md:tw-w-2/3">
                    <input
                        type="text"
                        class="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-bg-transparent tw-rounded tw-mt-2"
                        :placeholder="__('purchase.confirm_email_address_placeholder')"
                        v-model="confirmEmailAddress"
                        :class="{ 'tw-border-red-500': showConfirmEmailAddressError, 'tw-text-white': (theme === 'light') }"
                        @blur="fieldTouched.confirm_email_address = true"
                        @input="fieldTouched.confirm_email_address = true"
                    />
                    <span v-show="showConfirmEmailAddressError" class="tw-text-red-600">
                        {{ errors.confirm_email_address }}
                    </span>
                </div>
            </div>

            <div class="tw-flex tw-justify-center">
                <div class="tw-w-full md:tw-w-2/3">
                    <input
                        type="text"
                        class="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-bg-transparent tw-rounded tw-mt-2"
                        :placeholder="__('purchase.billing_email_address_placeholder')"
                        v-model="billingEmailAddress"
                        ref="billing_email_address"
                        :class="{ 'tw-border-red-500': showBillingEmailAddressError, 'tw-text-white': (theme === 'light') }"
                        @blur="fieldTouched.billing_email_address = true"
                        @input="fieldTouched.billing_email_address = true"
                    />
                    <span v-show="showBillingEmailAddressError" class="tw-text-red-600">
                        {{ errors.billing_email_address }}
                    </span>
                </div>
            </div>

            <div class="tw-flex tw-justify-center">
                <div class="tw-w-full md:tw-w-2/3">
                    <input
                        type="text"
                        class="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-bg-transparent tw-rounded tw-mt-2"
                        :placeholder="__('purchase.address_placeholder') + ' 1*'"
                        v-model="address1"
                        :class="{ 'tw-border-red-500': showAddress1Error, 'tw-text-white': (theme === 'light') }"
                        @blur="fieldTouched.address_1 = true"
                        @input="fieldTouched.address_1 = true"
                    />
                    <span v-show="showAddress1Error" class="tw-text-red-600">
                        {{ errors.address_1 }}
                    </span>
                </div>
            </div>

            <div class="tw-flex tw-justify-center">
                <div class="tw-w-full md:tw-w-2/3">
                    <input
                        type="text"
                        class="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-bg-transparent tw-rounded tw-mt-2"
                        :class="{'tw-text-white': (theme === 'light')}"
                        :placeholder="__('purchase.address_placeholder') + ' 2'"
                        v-model="address2"
                    />
                </div>
            </div>

            <div class="tw-flex tw-justify-center">
                <div class="tw-w-full md:tw-w-2/3">
                    <div class="tw-flex tw-flex-wrap tw-justify-center">
                        <div class="tw-w-full md:tw-w-1/2 tw-pr-2">
                            <input
                                type="text"
                                class="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-bg-transparent tw-rounded tw-mt-2"
                                :placeholder="__('purchase.city_placeholder')"
                                v-model="city"
                                :class="{ 'tw-border-red-500': showCityError, 'tw-text-white': (theme === 'light') }"
                                @blur="fieldTouched.city = true"
                                @input="fieldTouched.city = true"
                            />
                            <span v-show="showCityError" class="tw-text-red-600">
                                {{ errors.city }}
                            </span>
                        </div>

                        <div class="tw-w-full md:tw-w-1/2 tw-pl-2">
                            <input
                                type="text"
                                class="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-bg-transparent tw-rounded tw-mt-2"
                                :placeholder="__('purchase.postal_code_placeholder')"
                                @input="handlePostalCodeInput"
                                @blur="fieldTouched.postal_code = true"
                                v-model="postalCode"
                                :class="{ 'tw-border-red-500': showPostalCodeError, 'tw-text-white': (theme === 'light') }"
                            />
                            <span v-show="showPostalCodeError" class="tw-text-red-600">
                                {{ errors.postal_code }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tw-flex tw-justify-center">
                <div class="tw-w-full md:tw-w-2/3">
                    <div class="tw-flex tw-flex-wrap">
                        <div class="tw-w-full md:tw-w-1/2 tw-pr-2">
                            <select
                                class="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-bg-transparent tw-rounded tw-mt-4 tw-mb-4"
                                v-model="province"
                                :class="{ 'tw-border-red-500': showProvinceError, 'tw-border-white tw-text-white': (theme === 'light') }"
                                @change="provinceDidChange"
                                @blur="fieldTouched.province = true"
                            >
                                <option class="tw-bg-gray-800" disabled value="">
                                    {{ __('purchase.province_placeholder') }}
                                </option>
                                <option
                                    class="tw-bg-gray-800"
                                    v-for="(province, index) in provinces"
                                    :key="index"
                                    :value="province.code"
                                >
                                    {{ province.name }}
                                </option>
                            </select>
                            <span v-show="showProvinceError" class="tw-text-red-600">
                                {{ errors.province }}
                            </span>
                        </div>

                        <div class="tw-w-full md:tw-w-1/2 tw-pl-2">
                            <input
                                type="text"
                                class="tw-w-full tw-px-3 tw-py-2 tw-border tw-border-gray-300 tw-bg-transparent tw-rounded tw-mt-0 md:tw-mt-4"
                                :placeholder="__('purchase.country_placeholder')"
                                v-model="country"
                                :class="{ 'tw-border-red-500': showCountryError, 'tw-text-white': (theme === 'light') }"
                                @blur="fieldTouched.country = true"
                                @input="fieldTouched.country = true"
                                disabled
                            />
                            <span v-show="showCountryError" class="tw-text-red-600">
                                {{ errors.country }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted, getCurrentInstance, computed } from "vue";
import { useForm, useField } from "vee-validate";
import * as yup from "yup";

interface BillingDetails {
    firstName: string;
    lastName: string;
    emailAddress: string;
    confirmEmailAddress: string;
    billingEmailAddress: string;
    address1: string;
    address2: string;
    province: string;
    postalCode: string;
    city: string;
    country: string;
}

interface Province {
    name: string;
    code: string;
}

interface Props {
    currentBillingDetails?: BillingDetails;
    theme?: string;
}

const props = withDefaults(defineProps<Props>(), {
    currentBillingDetails: () => ({
        firstName: "",
        lastName: "",
        emailAddress: "",
        confirmEmailAddress: "",
        billingEmailAddress: "",
        address1: "",
        address2: "",
        province: "",
        postalCode: "",
        city: "",
        country: "Canada",
    }),
    theme: "light",
});

const emit = defineEmits<{
    "billing-details-did-submit": [billingDetails: BillingDetails];
    "province-did-change": [province: string];
}>();

const instance = getCurrentInstance();
const __ = instance?.appContext.config.globalProperties.__;

// Setup provinces
const provinces = ref<Province[]>([]);

// Track which fields have been touched by the user
const fieldTouched = reactive({
    first_name: false,
    last_name: false,
    email_address: false,
    confirm_email_address: false,
    billing_email_address: false,
    address_1: false,
    city: false,
    postal_code: false,
    province: false,
    country: false,
});

// Create validation schema
const validationSchema = yup.object({
    first_name: yup
        .string()
        .required(__('purchase.validation.required', { field: __('purchase.field_names.first_name') }))
        .matches(/^[a-zA-Z\- ]*$/, __('purchase.validation.alphabetic_only', { field: __('purchase.field_names.first_name') })),
    last_name: yup
        .string()
        .required(__('purchase.validation.required', { field: __('purchase.field_names.last_name') }))
        .matches(/^[a-zA-Z\- ]*$/, __('purchase.validation.alphabetic_only', { field: __('purchase.field_names.last_name') })),
    email_address: yup
        .string()
        .required(__('purchase.validation.required', { field: __('purchase.field_names.email_address') }))
        .test('email-format', __('purchase.validation.email', { field: __('purchase.field_names.email_address') }), function(value) {
            if (!value) return true; // Let required handle empty values
            const emailRegex = /^(?!.*\.\.)[a-zA-Z0-9._%+'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return emailRegex.test(value);
        }),
    confirm_email_address: yup
        .string()
        .required(__('purchase.validation.required', { field: __('purchase.field_names.confirm_email_address') }))
        .test("email-match", __('purchase.validation.confirmed', { field: __('purchase.field_names.confirm_email_address') }), function (value) {
            return value === this.parent.email_address;
        }),
    billing_email_address: yup
        .string()
        .test('email-format', __('purchase.validation.email', { field: __('purchase.field_names.billing_email_address') }), function(value) {
            if (!value) return true; // Optional field, so empty is valid
            
            const emailRegex = /^(?!.*\.\.)[a-zA-Z0-9._%+'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;            
            return emailRegex.test(value);
        })
        .nullable(),
    address_1: yup
        .string()
        .required(__('purchase.validation.required', { field: __('purchase.field_names.address_1') })),
    city: yup
        .string()
        .required(__('purchase.validation.required', { field: __('purchase.field_names.city') }))
        .matches(/^[a-zA-Z ]*$/, __('purchase.validation.alphabetic_only', { field: __('purchase.field_names.city') })),
    postal_code: yup
        .string()
        .required(__('purchase.validation.required', { field: __('purchase.field_names.postal_code') }))
        .matches(/^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/, __('purchase.validation.postal_code_format', { field: __('purchase.field_names.postal_code') })),
    province: yup
        .string()
        .required(__('purchase.validation.required', { field: __('purchase.field_names.province') })),
    country: yup
        .string()
        .required(__('purchase.validation.required', { field: __('purchase.field_names.country') }))
        .matches(/^[a-zA-Z]*$/, __('purchase.validation.alphabetic_only', { field: __('purchase.field_names.country') })),
});

// Setup form validation
const { handleSubmit, errors } = useForm({
    validationSchema,
    validateOnMount: false,
});

// Use field for each form field
const { value: firstName } = useField<string>("first_name");
const { value: lastName } = useField<string>("last_name");
const { value: emailAddress } = useField<string>("email_address");
const { value: confirmEmailAddress } = useField<string>("confirm_email_address");
const { value: billingEmailAddress } = useField<string>("billing_email_address");
const { value: address1 } = useField<string>("address_1");
const { value: address2 } = useField<string>("address_2");
const { value: city } = useField<string>("city");
const { value: postalCode } = useField<string>("postal_code");
const { value: province } = useField<string>("province");
const { value: country } = useField<string>("country");

// Computed properties to control when errors should be shown
const showFirstNameError = computed(() => fieldTouched.first_name && errors.value.first_name);
const showLastNameError = computed(() => fieldTouched.last_name && errors.value.last_name);
const showEmailAddressError = computed(() => fieldTouched.email_address && errors.value.email_address);
const showConfirmEmailAddressError = computed(() => fieldTouched.confirm_email_address && errors.value.confirm_email_address);
const showBillingEmailAddressError = computed(() => fieldTouched.billing_email_address && errors.value.billing_email_address);
const showAddress1Error = computed(() => fieldTouched.address_1 && errors.value.address_1);
const showCityError = computed(() => fieldTouched.city && errors.value.city);
const showPostalCodeError = computed(() => fieldTouched.postal_code && errors.value.postal_code);
const showProvinceError = computed(() => fieldTouched.province && errors.value.province);
const showCountryError = computed(() => fieldTouched.country && errors.value.country);

// Initialize data on mount
onMounted(() => {
    // Setup provinces from window.s.provinces
    const allProvincesObject = (window as any).s.provinces;
    allProvincesObject.forEach((element: any) => {
        provinces.value.push({
            name: element.name,
            code: element.code
        });
    });

    // Initialize form values from props
    if (props.currentBillingDetails) {
        firstName.value = props.currentBillingDetails.firstName || "";
        lastName.value = props.currentBillingDetails.lastName || "";
        emailAddress.value = props.currentBillingDetails.emailAddress || "";
        confirmEmailAddress.value = props.currentBillingDetails.confirmEmailAddress || "";
        billingEmailAddress.value = props.currentBillingDetails.billingEmailAddress || "";
        address1.value = props.currentBillingDetails.address1 || "";
        address2.value = props.currentBillingDetails.address2 || "";
        city.value = props.currentBillingDetails.city || "";
        postalCode.value = props.currentBillingDetails.postalCode || "";
        province.value = props.currentBillingDetails.province || "";
        country.value = props.currentBillingDetails.country || "Canada";
    }
});

// Handle postal code input to uppercase
const handlePostalCodeInput = (event: Event) => {
    const target = event.target as HTMLInputElement;
    postalCode.value = target.value.toUpperCase();
    fieldTouched.postal_code = true;
};

// Province change handler
const provinceDidChange = () => {
    fieldTouched.province = true;
    emit("province-did-change", province.value as string);
};

// Form submission handler
const formWillSubmit = handleSubmit((values) => {
    const billingDetails: BillingDetails = {
        firstName: values.first_name,
        lastName: values.last_name,
        emailAddress: values.email_address,
        confirmEmailAddress: values.confirm_email_address,
        billingEmailAddress: values.billing_email_address || "",
        address1: values.address_1,
        address2: (address2.value as string) || "",
        city: values.city,
        postalCode: values.postal_code,
        province: values.province,
        country: values.country,
    };
    
    emit("billing-details-did-submit", { ...{}, ...billingDetails });
}, () => {
    // Mark all fields as touched so errors show when validation fails
    fieldTouched.first_name = true;
    fieldTouched.last_name = true;
    fieldTouched.email_address = true;
    fieldTouched.confirm_email_address = true;
    fieldTouched.billing_email_address = true;
    fieldTouched.address_1 = true;
    fieldTouched.city = true;
    fieldTouched.postal_code = true;
    fieldTouched.province = true;
    fieldTouched.country = true;
    
    // Handle validation errors - scroll to error
    const errorElement = document.querySelector(".tw-border-red-500");
    if (errorElement) {
        errorElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
});

// Expose methods for parent component access
defineExpose({
    formWillSubmit,
});
</script>

